import React, { FC } from 'react';
import cls from 'classnames';

import { LazyImgix } from 'src/explore/elements/LazyImgix';

import styles from './index.module.sass';

interface LogoProps {
  className?: {
    container?: string;
    image?: string;
  };
  image?: string;
  link: string | null;
  name: string;
  width?: number;
}

const Logo: FC<LogoProps> = ({ className, image, link, name, width = 600 }) => (
  <h1 className={className?.container}>
    {/* GBMC forces relative paths thus requires prepending '//' :( */}
    <a className={styles.link} href={link ? `//${link}` : '/'} title={`${name} on Goldbelly`}>
      {image ? (
        <LazyImgix
          alt={name}
          className={cls( 'header-logo__img', styles.logo, className?.image )}
          src={image}
          width={width}
        />
      ) : (
        name
      )}
    </a>
  </h1>
);

export default Logo;
